// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Home = function Home(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.54 1.31a.835.835 0 0 0-1.08 0L.294 9.086a.835.835 0 0 0-.098 1.174.835.835 0 0 0 1.174.097l.854-.722v6.475a2.777 2.777 0 0 0 2.778 2.778h10a2.777 2.777 0 0 0 2.778-2.778V9.636l.85.722a.832.832 0 1 0 1.077-1.271zM3.89 16.11V8.222l6.112-5.184 6.111 5.184v7.89a1.11 1.11 0 0 1-1.111 1.11h-1.667v-5.277c0-.768-.621-1.39-1.389-1.39H8.057c-.767 0-1.388.622-1.388 1.39v5.277H5.002a1.11 1.11 0 0 1-1.111-1.11m4.445 1.111v-5h3.334v5z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
